module.exports = __webpack_public_path__ + "img/store-squarespace.2a720f48.svg";